module.exports = __webpack_public_path__ + "img/lottery_bg_icon.e27aa7a9.png";